// Global Instructions Rule Applied!

import {
  FilterValue,
  SortConfig,
  SetFilterOptionsAction,
  SetRoundsAction,
  SetActiveFiltersAction,
  SetActiveSortingAction,
  ClearActiveFiltersAction,
  UpdateRoundRecordAction,
  AddRoundAction,
  RemoveRoundAction
} from '../../interfaces/rounds.ts'
import { TableFilterOptionsResponse } from '../../rpc_models/get_table_filter_options_response.ts'
import { RoundEntry } from '../../data_models/round_entry.ts'
import {
  SET_FILTER_OPTIONS,
  SET_ROUNDS,
  SET_ACTIVE_FILTERS,
  SET_ACTIVE_SORTING,
  CLEAR_ACTIVE_FILTERS,
  UPDATE_ROUND_RECORD,
  ADD_ROUND,
  REMOVE_ROUND
} from './constants.ts'

const setFilterOptions = ({ response }: { response: TableFilterOptionsResponse }): SetFilterOptionsAction => ({
  type: SET_FILTER_OPTIONS,
  payload: { response }
})

const setRounds = ({ rounds }: { rounds: RoundEntry[] }): SetRoundsAction => ({
  type: SET_ROUNDS,
  payload: { rounds }
})

const setActiveFilters = ({ filters }: { filters: FilterValue[] }): SetActiveFiltersAction => ({
  type: SET_ACTIVE_FILTERS,
  payload: { filters }
})

const setActiveSorting = ({ sorting }: { sorting: SortConfig | null }): SetActiveSortingAction => ({
  type: SET_ACTIVE_SORTING,
  payload: { sorting }
})

const clearActiveFilters = (): ClearActiveFiltersAction => ({
  type: CLEAR_ACTIVE_FILTERS,
  payload: {}
})

export const updateRoundRecord = ({
  roundId,
  updates
}: {
  roundId: string
  updates: Record<string, any>
}): UpdateRoundRecordAction => ({
  type: UPDATE_ROUND_RECORD,
  payload: { roundId, updates }
})

export const addRound = ({ round }: { round: RoundEntry }): AddRoundAction => ({
  type: ADD_ROUND,
  payload: { round }
})

/** Drops a deleted round from the slice so no list or form keeps rendering it. */
export const removeRound = ({ roundId }: { roundId: string }): RemoveRoundAction => ({
  type: REMOVE_ROUND,
  payload: { roundId }
})
